import { render, staticRenderFns } from "./kyb-use-dialog.vue?vue&type=template&id=79a714cc&scoped=true"
import script from "./kyb-use-dialog.vue?vue&type=script&lang=js"
export * from "./kyb-use-dialog.vue?vue&type=script&lang=js"
import style0 from "./kyb-use-dialog.vue?vue&type=style&index=0&id=79a714cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a714cc",
  null
  
)

export default component.exports